import React from 'react';
import styled from 'styled-components';
import { IoAlertCircle } from 'react-icons/io5';
import { AiOutlineDownload } from 'react-icons/ai';
import { Loader } from 'playup-web-core';

import { parseErrorsToArray } from '../../utils/parseApiError';
import Modal from '../../components/Modal';
import ResponsibleGambling from '../../User/components/ResponsibleGambling';

const GeocomplyModal: React.FC<Props> = ({
	close,
	error,
	requestPending,
	requestGeolocation,
	plcInstallUrl,
	plcNotInstalled,
	visible,
}) => {
	const errorMessages = parseErrorsToArray(error);

	return visible ? (
		<Modal onClose={close} bg wrapperClassName="_w-3/4 _md:w-1/2 _mx-auto">
			<ModalBody>
				<IoAlertCircle size={60} />
				<h2>Geolocation Error</h2>
				{requestPending && (
					<div className="geocomply-loading">
						<Loader color="black" size={20} />
						Verifying location...
					</div>
				)}

				{plcNotInstalled ? (
					<PLCPrompt plcInstallUrl={plcInstallUrl} requestGeolocation={requestGeolocation} />
				) : (
					<>
						{errorMessages.map((errorMessage) => {
							// a bit clunky solution to replace new line characters with <br /> without using dangerouslySetInnerHTML
							const errorRows = errorMessage.message?.split(/\r\n|\r\n|\n|\r/g);
							return (
								<p key={errorMessage.key}>
									{errorRows?.map((row, i) => (
										<span key={i}>
											{row}
											<br />
										</span>
									))}
								</p>
							);
						})}
						<button className="_btn _btn-primary" onClick={close}>
							OK
						</button>
						<button className="_btn _btn-black" onClick={requestGeolocation}>
							Try Again
						</button>
					</>
				)}
				<ResponsibleGambling />
			</ModalBody>
		</Modal>
	) : null;
};

export default GeocomplyModal;

interface Props {
	close: () => void;
	error: APIError | null;
	plcInstallUrl: string | null;
	plcNotInstalled: boolean;
	requestGeolocation: () => void;
	requestPending: boolean;
	visible: boolean;
}

const ModalBody = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 1rem;
	color: #000;

	h2 {
		font-size: 2rem;
		font-weight: 700;
		margin: 1rem auto 1.5rem;
		text-align: center;
	}

	> p {
		margin-bottom: 1.2rem;
		font-size: 0.9rem;
		width: 100%;
	}

	.geocomply-loading {
		display: flex;
		align-items: center;
		margin-bottom: 0.5rem;
		> div {
			margin-right: 0.5rem;
		}
	}

	button {
		width: 100%;
		margin-bottom: 1.4rem;
		font-size: 1rem;
		display: flex;
		justify-content: center;
		align-items: center;
		line-height: 1;

		svg {
			display: inline-block;
			margin-right: 0.25rem;
			height: 1rem;
		}
	}
`;

const PLCPrompt: React.FC<Pick<Props, 'plcInstallUrl' | 'requestGeolocation'>> = ({
	plcInstallUrl,
	requestGeolocation,
}) => (
	<>
		<p>We are required by law to detect your location in order to ensure that you can place wagers.</p>
		{plcInstallUrl ? (
			<>
				<p>
					Please download and install the Geolocation software <strong>"Player Location Check"</strong> which allows us
					to verify that you are in an approved area to place a bet
				</p>
				<p>After installation feel free to start betting again. Or press "Try Again" Below</p>
				<button
					className="_btn _btn-primary"
					onClick={() => {
						window.open(plcInstallUrl);
					}}
				>
					<AiOutlineDownload />
					Download
				</button>
				<button className="_btn _btn-black" onClick={requestGeolocation}>
					Try Again
				</button>
			</>
		) : (
			<p>The Geolocation software is available for Windows and Macintosh computers.</p>
		)}
	</>
);
